export default function ShowEmail(user: string, domain: string) {
    const generateEmail = (user: string, domain: string) => {
        return `${user}@${domain}`;
    };

    const email = generateEmail(user, domain);

    return (<a href={`mailto:${email}`}>{email}</a>);
}
